import React from 'react';
import { Link } from 'react-router-dom'

import Banner from '../App/Banner';

import Check from '../../assets/check.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function Europe() {
  return(
    <div>
      <Banner />
      <div id="europe" className='paper'>

        <Link to='/'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
        </Link>

        <div className="breadcrumbs">
          <p><img src={Check} />Votre stock se situe en Union Européenne</p>
        </div>

        <h2>Vous vendez vers :</h2>
          <div className="select_container">
            <Link to='/SameCountry'><button className='select'>Le pays du stock</button></Link>
            <Link to='/OSSUE'><button className='select'>Un autre pays de l'UE</button></Link>
            <Link to='/UEToHorsUE'><button className='select'>Hors UE</button></Link>
            <Link to='/UEtoUK'><button className='select'>Le royaume uni</button></Link>
          </div>
        
      </div>

    </div>
  )
}

export default Europe